import { lazy } from "react";
import Loadable from "../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../router/AuthorizedRoute";
import { LEADS_MODULE_IDS } from "../../../../enums/leads";

const FollowUps = Loadable(
  lazy(() =>
    import("./FollowUpsList").then(({ FollowUpsList }) => ({
      default: FollowUpsList,
    }))
  )
);

const ManageFollowUps = Loadable(
  lazy(() =>
    import("./ManageFollowUpsTabs").then(({ ManageFollowUpsTabs }) => ({
      default: ManageFollowUpsTabs,
    }))
  )
);

export const followUpsRoutes = [
  {
    path: "/follow-ups",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[LEADS_MODULE_IDS.FOLLOW_UP]}>
        <FollowUps />
      </AuthorizedRoute>
    ),
  },
  {
    path: "/follow-ups/manage",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[LEADS_MODULE_IDS.FOLLOW_UP]}>
        <ManageFollowUps />
      </AuthorizedRoute>
    ),
  },

  {
    path: "/follow-ups/manage/:followUpCode",
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[LEADS_MODULE_IDS.FOLLOW_UP]}>
        <ManageFollowUps />
      </AuthorizedRoute>
    ),
  },
];
